import { MerchantInfoEntity, RawMerchantInfo } from './Types';
import { RawStore, StoreEntity } from '../Store/Types';
import { StoreModel } from '../Store/StoreModel';
import { BaseModel } from '../BaseModel/BaseModel';

export class MerchantInfoModel
    extends BaseModel<RawMerchantInfo, MerchantInfoEntity>
    implements MerchantInfoEntity
{
    categoryName?: string = '';
    depth?: number = 0;
    description?: string = '';
    descriptionShort?: string = '';
    height?: number = 0;
    idLang?: number = 0;
    idProduct?: number = 0;
    image?: string = '';
    link?: string = '';
    metaDescription?: string = '';
    metaTitle?: string = '';
    productPrice?: number = 0;
    weight?: number = 0;
    width?: number = 0;
    stores?: Record<string, StoreEntity> = { '0': new StoreModel() };
    eanCode?: string;
    grossWeight?: string;
    pargoAvailable?: string;
    productLabel?: string;
    SKU?: string;

    constructor(data?: RawMerchantInfo) {
        super();
        if (data) {
            this.initialize(data);
        }
    }

    initialize(data: RawMerchantInfo) {
        this.categoryName = data.category_name;
        this.depth = data.depth;
        this.description = data.description;
        this.descriptionShort =
            data.description_short ?? data['Short Description'];
        this.height = data.height;
        this.idLang = data.id_lang;
        this.idProduct = data.id_product;
        this.image = data.image;
        this.link = data.link;
        this.metaDescription = data.meta_description;
        this.metaTitle = data.meta_title;
        this.productPrice = data.product_price;
        this.weight = data.weight;
        this.width = data.width;
        this.eanCode = data['Ean code'];
        this.grossWeight = data['Gross weight'];
        this.pargoAvailable = data['Pargo Available'];
        this.productLabel = data['Product label'];
        this.SKU = data.SKU;

        this.stores = data.stores
            ? Object.entries(data.stores).reduce(
                  (acc, [key, rawStore]) => {
                      acc[key] = new StoreModel(rawStore);
                      return acc;
                  },
                  {} as Record<string, StoreEntity>
              )
            : {};
    }

    parse(): RawMerchantInfo {
        return {
            link: this.link,
            image: this.image,
            ...(this.categoryName && { category_name: this.categoryName }),
            ...(this.depth && { depth: this.depth }),
            ...(this.description && { description: this.description }),
            ...(this.descriptionShort && {
                description_short: this.descriptionShort,
            }),
            ...(this.height && { height: this.height }),
            ...(this.idLang && { id_lang: this.idLang }),
            ...(this.idProduct && { id_product: this.idProduct }),
            ...(this.metaDescription && {
                meta_description: this.metaDescription,
            }),
            ...(this.metaTitle && { meta_title: this.metaTitle }),
            ...(this.productPrice && { product_price: this.productPrice }),
            ...(this.weight && { weight: this.weight }),
            ...(this.width && { width: this.width }),
            ...(this.stores && {
                stores: Object.entries(this.stores).reduce(
                    (acc, [key, store]) => {
                        acc[key] = store.parse();
                        return acc;
                    },
                    {} as Record<string, RawStore>
                ),
            }),
            ...(this.eanCode && { 'Ean code': this.eanCode }),
            ...(this.SKU && { SKU: this.SKU }),
            ...(this.grossWeight && { 'Gross weight': this.grossWeight }),
            ...(this.pargoAvailable && {
                'Pargo Available': this.pargoAvailable,
            }),
            ...(this.productLabel && { 'Product label': this.productLabel }),
        };
    }
}
